"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var typeUtils_1 = require("ContentTokens/Models/inputs/typeUtils");
var Types_1 = require("ContentTokens/Models/inputs/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var WidgetMenuButton_1 = __importDefault(require("Project/QwilrEditor/Widgets/WidgetMenuButton"));
var LinkInputBox_1 = __importDefault(require("Project/QwilrEditor/Widgets/LinkInputBox"));
var CorrectLink_1 = __importDefault(require("@CommonFrontendBackend/Utils/CorrectLink"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var TokenInput_1 = __importDefault(require("Project/QwilrEditor/Widgets/TokenMenu/TokenInput"));
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
var Types_3 = require("Tokens/Types");
var SubstitutionTokenFactory_1 = __importDefault(require("Tokens/SubstitutionTokenFactory"));
var assertCheckIsExhaustive_1 = require("Utils/assertCheckIsExhaustive");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var getLinkHref = function (href) {
    return (0, lodash_1.isString)(href) ? href : "";
};
var getTokenHref = function (href) {
    return (0, typeUtils_1.isTokenInput)(href)
        ? {
            name: href.name,
            label: href.label,
        }
        : undefined;
};
var ButtonWidgetLinkMenu = (function (_super) {
    __extends(ButtonWidgetLinkMenu, _super);
    function ButtonWidgetLinkMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.textInput = null;
        _this.onClickTokenButton = function () {
            var _a = _this.props, href = _a.href, removeToken = _a.removeToken;
            if ((0, typeUtils_1.isTokenInput)(href)) {
                removeToken();
            }
            _this.showLinkInput = !_this.showLinkInput;
        };
        _this.onTokenMatchedBySearch = function (token) {
            _this.tokenMatchedBySearch = token;
        };
        _this.onTokenChange = function (token) {
            var _a = _this.props, confirmToken = _a.confirmToken, removeToken = _a.removeToken, close = _a.close;
            if (token) {
                confirmToken(new Types_1.TokenInput(token.apiName, token.name, SubstitutionTokenFactory_1.default.fromLegacyApiToken(token)));
            }
            else {
                removeToken();
            }
            close();
        };
        _this.removeLink = function () {
            var _a = _this.props, updateLink = _a.updateLink, close = _a.close, removeToken = _a.removeToken;
            updateLink("");
            removeToken();
            close();
        };
        _this.onInputBlur = function (event, rawHref) {
            var _a = _this.props, updateLink = _a.updateLink, close = _a.close;
            var href = (0, CorrectLink_1.default)(rawHref);
            updateLink(href);
            close();
        };
        _this.onConfirm = function () {
            if (_this.textInput) {
                _this.textInput.blur();
            }
            else if (_this.tokenMatchedBySearch) {
                _this.onTokenChange(_this.tokenMatchedBySearch);
            }
            else {
                _this.props.close();
            }
        };
        _this.getTextInputElement = function (elem) {
            _this.textInput = elem;
        };
        if (!props.href || (0, lodash_1.isString)(props.href)) {
            _this.showLinkInput = true;
        }
        else if ((0, typeUtils_1.isTokenInput)(props.href)) {
            _this.showLinkInput = false;
        }
        else {
            (0, assertCheckIsExhaustive_1.assertCheckIsExhaustive)(props.href);
        }
        return _this;
    }
    ButtonWidgetLinkMenu.prototype.render = function () {
        var _a = this.props, href = _a.href, tokensEnabled = _a.tokensEnabled;
        return (react_1.default.createElement("div", { className: "editor-toolbar button-token-link-menu" },
            this.showLinkInput && (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Link is not a valid URL", size: kaleidoscope_1.TooltipSize.Large, show: this.props.hasError },
                react_1.default.createElement(LinkInputBox_1.default, { href: getLinkHref(href), placeholder: "Paste your link here", onInputBlur: this.onInputBlur, blurInput: this.onConfirm, getTextInputElement: this.getTextInputElement }))),
            !this.showLinkInput && (react_1.default.createElement(TokenInput_1.default, { type: Types_2.TokenDataType.String, token: getTokenHref(href), onTokenChange: this.onTokenChange, onTokenMatchedBySearch: this.onTokenMatchedBySearch })),
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Tick, null), onMouseDown: this.onConfirm }),
            tokensEnabled && (react_1.default.createElement(WidgetMenuButton_1.default, { icon: (0, typeUtils_1.isTokenInput)(href) ? react_1.default.createElement(icons_1.RemoveToken, null) : react_1.default.createElement(icons_1.Tokens, null), onMouseDown: this.onClickTokenButton, tooltipMessage: (0, typeUtils_1.isTokenInput)(href) ? "Remove Token" : "Add Token" })),
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Unlink, null), onMouseDown: this.removeLink })));
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], ButtonWidgetLinkMenu.prototype, "showLinkInput", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof Types_3.Token !== "undefined" && Types_3.Token) === "function" ? _a : Object)
    ], ButtonWidgetLinkMenu.prototype, "tokenMatchedBySearch", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ButtonWidgetLinkMenu.prototype, "onClickTokenButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ButtonWidgetLinkMenu.prototype, "onTokenMatchedBySearch", void 0);
    ButtonWidgetLinkMenu = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ButtonWidgetLinkMenu);
    return ButtonWidgetLinkMenu;
}(react_1.default.Component));
exports.default = ButtonWidgetLinkMenu;
